import { PropsWithChildren } from "react";

import { css } from "@compiled/react";

import { AtlassianLogo } from "@atlaskit/logo";
import { media } from "@atlaskit/primitives";
import { token } from "@atlaskit/tokens";

export const Modal = ({
    children,
    showBlueHeaderOnMobile,
    showBrandFooter,
    size
}: PropsWithChildren<{
    showBlueHeaderOnMobile?: boolean;
    size?: "sm" | "lg";
    showBrandFooter?: boolean;
}>) => (
    <div
        css={[positioningCss, showBlueHeaderOnMobile && blueHeaderOnMobileCss]}
        data-testid="modal"
    >
        <div
            css={[
                modalCss,
                size === "sm" && smModalCss,
                size === "lg" && lgModalCss
            ]}
        >
            {children}
        </div>
        {showBrandFooter && (
            <>
                <div css={smVisibleCss} aria-hidden="true">
                    <AtlassianLogo appearance="brand" size="small" />
                </div>
                <div css={lgVisibleCss} aria-hidden="true">
                    <AtlassianLogo appearance="inverse" size="small" />
                </div>
            </>
        )}
    </div>
);

const blueHeaderOnMobileCss = css({
    backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 1440 518' preserveAspectRatio='none' fill='%23E9F2FE' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1331.5 -20.8369L-38.614 -36.9811L-43.579 433.588H243.576L248.105 518L1598.49 435.131L1574.37 -14.3789L1331.5 0.525597V-20.8369Z'/%3E%3C/svg%3E%0A")`,
    backgroundSize: "100% 120px",
    backgroundPosition: "center 0",
    backgroundRepeat: "no-repeat",
    paddingBlockStart: 42,
    [media.above.sm]: {
        backgroundImage: "none"
    }
});

const smVisibleCss = css({
    display: "block",
    [media.above.sm]: {
        display: "none"
    }
});

const lgVisibleCss = css({
    display: "none",
    [media.above.sm]: {
        display: "block"
    }
});

const modalCss = css({
    overflow: "hidden",
    transition: "width 0.5s ease-in-out",
    maxWidth: "100%",
    [media.above.sm]: {
        backgroundColor: token("elevation.surface"),
        borderRadius: 8,
        boxShadow: token("elevation.shadow.overlay"),
        minHeight: 400
    }
});

const smModalCss = css({
    width: 560
});

const lgModalCss = css({
    width: 1140
});

const positioningCss = css({
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: 32,
    padding: 24,
    [media.above.sm]: {
        justifyContent: "center",
        minHeight: "100vh",
        padding: 32,
        ["@supports (min-height: 100dvh)"]: {
            minHeight: "100dvh"
        }
    }
});
